import React, { useState, useEffect } from 'react';
import './Sec6Form.css';
import axios from 'axios'; // Import Axios
import Cookies from 'js-cookie';

function Sec6Form() {
  const [email, setEmail] = useState('');
  const [csrfToken, setCsrfToken] = useState(null); // Add this

  const [formData, setFormData] = useState({
    email: ''
  });

  // Fetch CSRF token when component mounts
  useEffect(() => {
    const fetchCsrfToken = async () => {
      try {
        const apiUrl = 'https://zinnov.com/centers-of-excellence/zinnov-nasscom-mid-market-global-capability-centers-gccs-2025-report/api/csrf-token.php';
        const res = await fetch(apiUrl, {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json'
          }
        });
        const data = await res.json();
        if (data.success) {
          setCsrfToken(data.csrfToken);
        }
      } catch (error) {
        console.error('Error fetching CSRF token:', error);
      }
    };

    fetchCsrfToken();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    const searchParams = new URLSearchParams(window.location.search);
    const utm_source = (!(searchParams.get('utm_source'))?'na':searchParams.get('utm_source'));
    const utm_campaign = (!(searchParams.get('utm_campaign'))?'na':searchParams.get('utm_campaign'));
    const utm_medium = (!(searchParams.get('utm_medium'))?'na':searchParams.get('utm_medium'));
    const utm_term = (!(searchParams.get('utm_term'))?'na':searchParams.get('utm_term'));
    const utm_content = (!(searchParams.get('utm_content'))?'na':searchParams.get('utm_content'));
    const hubspotutkCookie = Cookies.get('hubspotutk');

    var data = {
      "submittedAt": Date.now(),
      "fields": [
        {
          "objectTypeId": "0-1",
          "name": "email",
          "value": email
        },
        {
          "objectTypeId": "0-1",
          "name": "page_url",
          "value": window.location.href
        },
        {
          "objectTypeId": "0-1",
          "name": "utm_campaign",
          "value": utm_campaign
        },
        {
          "objectTypeId": "0-1",
          "name": "utm_content",
          "value": utm_content
        },
        {
          "objectTypeId": "0-1",
          "name": "utm_medium",
          "value": utm_medium
        },
        {
          "objectTypeId": "0-1",
          "name": "utm_source",
          "value": utm_source
        },
        {
          "objectTypeId": "0-1",
          "name": "utm_term",
          "value": utm_term
        }
      ],
      "context": {
            "hutk": hubspotutkCookie,
            "pageUri": window.location.href,
            "pageName": document.getElementsByTagName("title")[0].innerHTML
       },
      "csrfToken": csrfToken // ← ADD THIS LINE
    }

    var final_data = JSON.stringify(data);

    axios.post('https://zinnov.com/centers-of-excellence/why-set-up-global-capability-centers-in-india-blog/api/subscribe_to_newsletter.php', final_data, {
      headers: {
        'Content-Type': 'application/json'
      },
      withCredentials: true
    })
        .then(response => {
          // console.log('Subscribe to Newsletter  - Submit - Form data submitted:', response.data);
          setEmail(''); // Clear email on success
        })
        .catch(error => {
          console.error('Error submitting form data:', error);
          if (error.response?.status === 403) {
            alert('Security validation failed. Please refresh the page and try again.');
          } else {
            alert('Failed to subscribe. Please try again.');
          }
        });
  };

  return (
    <div className="subscribe-container container">
      <h3 className="Title subscribe-title">Never miss a story</h3>
      <p className="subscribe-description">Stay updated about ZINNOV news as it happens</p>
      <form onSubmit={handleSubmit} className="subscribe-form">
        <input
          type="email"
          placeholder="Your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="subscribe-input"
          required
        />
        <button type="submit" className="subscribe-button">Subscribe</button>
      </form>
    </div>
  );
}

export default Sec6Form;
